import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Hero from '../../components/hero'
import SearchSection from '../../components/SearchSection'
import Features from '../../components/Features'
import Pricing from '../../components/Pricing'
import Service from '../../components/Service'
import CtaSection from '../../components/cta'
import BlogSection from '../../components/BlogSection'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
import Faqs from '../../components/FaqSection';
import ContactForm from '../../components/Contactpage';
import About from '../../components/about';


const HomePage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <Hero heroclass={'wpo-hero-style-1'}/>
            <SearchSection sClass={'wpo-search-section section-padding'}/>
            <About/>
            <Features fClass={'wpo-features-area'}/>
            <Pricing pTitle={'Our Pricing Plan'}/>
            <Service/>
            <CtaSection/>
            <BlogSection/>
            <Faqs/>
            <ContactForm/>
            <Footer ftLogo={Logo}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage;